import React, { useState, useEffect } from 'react';
import './App.css';
import axios from 'axios';

// Components
import Header from './components/Header';
import Dashboard from './components/Dashboard';
import ZoneDetailPage from './components/ZoneDetailPage';
import FacilitiesPage from './components/FacilitiesPage';
import ZonesPage from './components/ZonesPage';
import UsersPage from './components/UsersPage';
import LoginPage from './components/LoginPage';

const API_URL = '/api';

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [user, setUser] = useState(null);
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [selectedZone, setSelectedZone] = useState(null);

  useEffect(() => {
    if (token) {
      loadUser();
    }
  }, [token]);

  const loadUser = async () => {
    try {
      const response = await axios.get(`${API_URL}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUser(response.data);
    } catch (err) {
      console.error('Kullanıcı bilgisi alınamadı:', err);
      if (err.response?.status === 401) {
        localStorage.removeItem('token');
        setToken(null);
      }
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
    setCurrentPage('dashboard');
    setSelectedZone(null);
  };

  if (!token) {
    return <LoginPage setToken={setToken} setUser={setUser} />;
  }

  return (
    <>
      <div className="data-flow">
        {[...Array(10)].map((_, i) => <div key={i} className="data-line"></div>)}
        {[...Array(5)].map((_, i) => <div key={i+10} className="data-line-horizontal"></div>)}
      </div>

      <div className="container">
        <Header 
          user={user} 
          onLogout={handleLogout}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          selectedZone={selectedZone}
          setSelectedZone={setSelectedZone}
        />

        {selectedZone ? (
          <ZoneDetailPage 
            token={token} 
            zoneId={selectedZone} 
            onBack={() => setSelectedZone(null)} 
          />
        ) : (
          <>
            {currentPage === 'dashboard' && <Dashboard token={token} user={user} onZoneClick={setSelectedZone} />}
            {currentPage === 'facilities' && user?.role === 'admin' && <FacilitiesPage token={token} />}
            {currentPage === 'zones' && user?.role === 'admin' && <ZonesPage token={token} />}
            {currentPage === 'users' && user?.role === 'admin' && <UsersPage token={token} />}
          </>
        )}
      </div>
    </>
  );
}

export default App;
